// // Products Slider ~ FROM WL

if(document.querySelector('.per-slide')) {
  let slidePerViewFromDrupal = document.querySelector('.per-slide').getAttribute('data-per-slide');

  if(slidePerViewFromDrupal === 'none') {
    slidePerViewFromDrupal = 3;
  } 
  
  (function () {
    var slider_list = document.querySelectorAll('.js_product_category_slider_v1');
  
    for (var i = 0; i < slider_list.length; i++) {
      const slider = slider_list[i];
  
      initProductSlider(slider);
    }
  
    function initProductSlider (slider) {
      var sliderOptions = {
        spaceBetween: 40,
        slidesPerView: 1,
        loop: true,
  
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 768px
          767: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          // when window width is >= 1200px
          1200: {
            slidesPerView: slidePerViewFromDrupal,
            spaceBetween: 40
          }
        },
        pagination: {
          el: '.js_product_category_slider_v1_pagination .swiper-pagination',
          clickable: true,
          dynamicBullets: false,
        },
        navigation: {
          nextEl: '.js_product_category_slider_v1_nav .swiper-button-next',
          prevEl: '.js_product_category_slider_v1_nav .swiper-button-prev',
        },
        on: { // custom added
          afterInit: function() {
            document.querySelector('.product-category-slider__body').classList.add('animate');
            document.querySelector('.product-category-slider__footer').classList.add('animate');
          }
        }
      }
  
      // Override from theme
      if (window.productProductCategoryV1verride) {
        sliderOptions = window.productProductCategoryV1verride;
      }
  
      var page_header_slider_v1 = new Swiper(slider, sliderOptions);
    }
  })();
}